import { Box, Button, FormControl, Grid, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import {
  AddEmployeeExpenseAction,
  GetEmployeeExpenseAction,
  GetExpenseSubtypeAction,
  GetExpenseTypeAction,
  UpdateApproverExpenseAction,
  UpdateEmployeeExpenseAction,
} from "../../../../../store/Finance/Expense/Action";
import { GetExpenseSubtypeHelper } from "../../../ExpenseSettings/helper/ExpenseTypeHelper";
import {
  convertBase64,
  getDomain,
  getImageSignedUrl,
} from "../../../Base/helper/baseFunctions";
import FileUploader from "../../../ATS/views/ATSCandidate/FileUploader";
import { APP_NAME } from "../../../../Constants/baseConstant";
import { grey } from "@mui/material/colors";
import { toast } from "react-toastify";

const AddExpensePopUp = ({ closeMode, editedRecord }) => {
  const initialState = {
    expense_type_id: "",
    sub_expense_type_id: "",
    entry_date: "",
    employee_amount: "",
  };
  const dispatch = useDispatch();
  const { expense_types } = useSelector(
    (state) => state?.FinanceReducer?.ExpenseReducer
  );
  const { minDojYear } = useSelector(state => state?.AncillaryReducer?.WorkSpaceDojReducer);
  const { company_logo } = useSelector(state => state?.AncillaryReducer?.LetterHeadReducer);
  const [expenseData, setExpenseData] = useState(initialState);
  const [files, setFiles] = useState([]);
  const [fileUrl, setFileUrl] = useState("");
  const [errors, setErrors] = useState({});
  const [typeData, setTypeData] = useState({
    load: true,
    values: [],
  });
  const [subTypeData, setSubTypeData] = useState({
    load: true,
    values: [],
  });
  const handleType = () => {
    expense_types && setTypeData({ load: false, values: expense_types });
  };
  const handleSubType = () => {
    if (expenseData?.expense_type_id?.expense_type_id) {
      GetExpenseSubtypeHelper({
        expense_type_id:
          `{${expenseData?.expense_type_id?.expense_type_id}}` || null,
      }).then((res) => {
        if (res?.data?.statuscode === 200) {
          setSubTypeData({ load: false, values: res?.data?.data });
        }
      });
    } else {
      setSubTypeData({ load: true, values: [] });
    }
  };

  const validate = (fieldValues) => {
    let temp = { ...errors };
    if ("expense_type_id" in fieldValues) {
      temp.expense_type_id =
        fieldValues.expense_type_id === "" ? "Category is required" : "";
    }
    if ("sub_expense_type_id" in fieldValues) {
      temp.sub_expense_type_id =
        fieldValues.sub_expense_type_id === "" ? "Subcategory is required" : "";
    }
    if ("entry_date" in fieldValues) {
      temp.entry_date = fieldValues.entry_date === "" ? "Date is required" : "";
    }
    if ("employee_amount" in fieldValues) {
      temp.employee_amount =
        fieldValues.employee_amount === "" ? "Amount is required" : "";
    }
    if (!files?.length && !fileUrl) {
      temp.proof = "Proof upload is required";
    } else {
      temp.proof = "";
    }
    setErrors({ ...temp });

    return Object.values(temp).every((x) => x === "");
  };
  const handleInput = (event, value) => {
    if (["sub_expense_type_id"].includes(event)) {
      if (value) {
        setExpenseData({ ...expenseData, [event]: value });
      } else {
        setExpenseData({ ...expenseData, [event]: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...expenseData, [event]: value ? value : "" });
    } else if (["expense_type_id"].includes(event)) {
      if (value) {
        setExpenseData({
          ...expenseData,
          [event]: value,
          sub_expense_type_id: "",
        });
        setSubTypeData({ load: true, values: [] });
      } else {
        setExpenseData({ ...expenseData, [event]: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...expenseData, [event]: value ? value : "" });
    } else {
      setExpenseData({
        ...expenseData,
        [event.target.name]: event.target.value,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({
          ...expenseData,
          [event.target.name]: event.target.value,
        });
    }
  };
  const handleSubmit = async () => {
    if (!validate(expenseData)) return;

    let b64string = "";
    let filename = "";
    let old_proof = "";
    let content_type = "";
    if (files?.[0]) {
      const file = files?.[0];
      b64string = await convertBase64(file);
      const ext = file?.name?.split(".").at(-1).toLowerCase();
      content_type = file?.type;
      filename =
        `${getDomain()}/ExpenseManagement/MyExpense/` + uuidv4() + "." + ext;
      if (editedRecord?.proof) {
        old_proof = editedRecord?.proof;
      }
    } else {
      filename = editedRecord?.proof;
    }
    if (editedRecord?.employee_expenses_pk) {
      dispatch(
        UpdateEmployeeExpenseAction({
          sub_expense_type_fk:
            expenseData?.sub_expense_type_id?.sub_expense_type_id,
          amount: expenseData?.employee_amount,
          employee_status: "Submitted",
          finance_approver_status: "Action Needed",
          date: expenseData?.entry_date,
          proof: filename,
          b64string: b64string,
          content_type: content_type,
          old_proof: old_proof,
          employee_expenses_pk: editedRecord?.employee_expenses_pk,
          approver_email: expenseData?.sub_expense_type_id?.approver_email
? expenseData?.sub_expense_type_id?.approver_email : expenseData?.approver_email,
          approverName: expenseData?.sub_expense_type_id?.approver_name
? expenseData?.sub_expense_type_id?.approver_name : expenseData?.approver_name,
          category: expenseData?.expense_type_id?.expense_type_name,
          subCategory: expenseData?.sub_expense_type_id?.sub_expense_type_name,
          company_logo: company_logo
        })
      );
    } else {
      const isApprovalReq = subTypeData?.values?.find(
        (el) =>
          el?.sub_expense_type_id ===
          expenseData?.sub_expense_type_id?.sub_expense_type_id
      );
      dispatch(
        AddEmployeeExpenseAction(
          {
            sub_expense_type_fk:
              expenseData?.sub_expense_type_id?.sub_expense_type_id,
            amount: expenseData?.employee_amount,
            employee_status: !isApprovalReq?.proof_approval_required
              ? "Approved"
              : "Submitted",
            finance_approver_status: !isApprovalReq?.proof_approval_required
              ? "Self Approved"
              : "Pending Approval",
            date: expenseData?.entry_date,
            proof: filename,
            b64string: b64string,
            content_type: content_type,
            approver_email: isApprovalReq?.approver_email,
            approverName: isApprovalReq?.approver_name,
            isApprovalReq: isApprovalReq?.proof_approval_required,
            category: isApprovalReq?.expense_type_name,
            subCategory: isApprovalReq?.sub_expense_type_name,
            company_logo: company_logo

          },
          (error, result) => {
            if (!error && result?.data?.statuscode === 200) {
              const resDataId = result?.data?.data?.[0]?.employee_expenses_pk;
              if (resDataId && !isApprovalReq?.proof_approval_required) {
                dispatch(
                  UpdateApproverExpenseAction({
                    user_id: 1,
                    employee_expenses_pk: resDataId,
                    finance_approver_amount: expenseData?.employee_amount,
                    finance_approver_status: "Self Approved",
                    employee_status: "Approved",
                    employee_side: true,
                  })
                );
              }
            } else {
              toast.dismiss();
              toast.error("Something went wrong");
            }
          }
        )
      );
    }
    closeMode();
  };

  const fileUploaded = () => {
    let temp = { ...errors };
    temp.proof = "";
    setErrors({
      ...temp,
    });
  };

  useEffect(() => {
    const handleData = async () => {
      if (editedRecord != null) {
        setExpenseData({
          ...editedRecord,
          expense_type_id: {
            expense_type_id: editedRecord?.expense_type_fk,
            expense_type_name: editedRecord?.expense_name,
          },
          sub_expense_type_id: {
            sub_expense_type_id: editedRecord?.sub_expense_type_fk,
            sub_expense_type_name: editedRecord?.sub_expense_type_name,
          },
        });
        if (editedRecord?.proof) {
          const url = await getImageSignedUrl(editedRecord?.proof);
          setFileUrl(url);
        }
      }
    };
    handleData();
  }, [editedRecord]);

  useEffect(() => {
    dispatch(GetExpenseSubtypeAction());
    dispatch(GetExpenseTypeAction());
    dispatch(GetEmployeeExpenseAction());
  }, [dispatch]);
  return (
    <>
      <Grid container>
        <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
          <FormControl fullWidth>
            <SelectableSearch
              label="Category"
              value={expenseData?.expense_type_id}
              loading={() => handleType()}
              fieldLabel="expense_type_name"
              name="expense_type_id"
              size="small"
              onChangeEvent={handleInput}
              data={typeData}
              required
              {...(errors?.expense_type_id && {
                error: true,
                helperText: errors?.expense_type_id,
              })}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
          <FormControl fullWidth>
            <SelectableSearch
              label="Subcategory"
              value={expenseData?.sub_expense_type_id}
              loading={() => handleSubType()}
              fieldLabel="sub_expense_type_name"
              name="sub_expense_type_id"
              size="small"
              onChangeEvent={handleInput}
              data={subTypeData}
              required
              {...(errors?.sub_expense_type_id && {
                error: true,
                helperText: errors?.sub_expense_type_id,
              })}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
          <FormControl fullWidth>
            <CommonDatePicker
              required
              name="entry_date"
              label="Date"
              size="small"
              pickerType="date"
              DefaultDTvalue={expenseData?.entry_date}
              pickerFormat="dd/MM/yyyy"
              maxDate={new Date(new Date().setMonth(new Date().getMonth() + 3))} 
              minDate={new Date(new Date(minDojYear).getFullYear() - 1, new Date(minDojYear).getMonth(), 1)} 
              handleChange={(value) =>
                handleInput({
                  target: {
                    name: "entry_date",
                    value: value
                      ? `${value?.getFullYear()}-${(
                          "0" +
                          (value.getMonth() + 1)
                        ).slice(-2)}-${("0" + value.getDate()).slice(-2)}`
                      : "",
                  },
                })
              }
              {...(errors?.entry_date && {
                error: true,
                helperText: errors?.entry_date,
              })}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
          <TextField
            fullWidth
            name="employee_amount"
            label="Amount"
            type="number"
            size="small"
            required
            value={expenseData?.employee_amount}
            onChange={handleInput}
            {...(errors?.employee_amount && {
              error: true,
              helperText: errors?.employee_amount,
            })}
          />
        </Grid>
        <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
          <Grid
            onChange={fileUploaded}
            sx={{
              textAlign: "center",
              border: "2px",
              padding: "20px",
              borderRadius: "10px",
              borderStyle: "dashed",
              backgroundColor: "primary",
              borderColor: grey[500],
            }}
          >
            <FileUploader
              files={files}
              setFiles={setFiles}
              fileUrl={fileUrl}
              setFileUrl={setFileUrl}
              task={true}  // for file type control
              isExpense={true}
              name={"Upload Proof"}
              filename={`ExpenseProof_${APP_NAME}`}
              filepath={expenseData?.proof}
            />
          </Grid>
          {errors?.proof && (
            <div
              style={{
                color: "red",
                paddingTop: "5px",
                fontSize: "11px",
                paddingLeft: "15px",
              }}
            >
              {errors?.proof}
            </div>
          )}
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "space-between", m: 1.5 }}>
        <Button
          className="mpl-primary-btn"
          variant="contained"
          size="medium"
          onClick={closeMode}
        >
          Cancel
        </Button>
        <Button
          className="mpl-primary-btn"
          variant="contained"
          size="medium"
          onClick={handleSubmit}
        >
          {editedRecord ? "Update" : "Save"}
        </Button>
      </Box>
    </>
  );
};

export default AddExpensePopUp;
